import React, { useRef, useEffect, useState } from 'react';
import { components } from 'react-select';
import { Box, Typography, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'

export const MultiValueContainer = ({ ...props }) => {
  const theme = useTheme();
  const selectedValuesCount = props.getValue().length;
  const { menuIsOpen } = props.selectProps
  const {t} = useTranslation()

  return (
    <components.ValueContainer {...props}>
      <Box>
        <Typography
          sx={{
            color: menuIsOpen ? '#3B82F6' : theme.palette.grey[500],
            fontSize: '12px',
            paddingLeft: theme.spacing(1.5),
            fontWeight: 500,
            whiteSpace: 'nowrap',
          }}
        >
          {
            selectedValuesCount === 0
              ? props.selectProps.placeholder
              : t('ui_elements.count_selected', {count: selectedValuesCount})
          }
        </Typography>
      </Box>
    </components.ValueContainer>
  );
};

const InputValue = (props) => {
  const inputRef = useRef(null);
  const [value, setValue] = useState('');
  console.log(props)
  useEffect(() => {
    inputRef.current.focus();
  }, []);
  
  const handleInput = (e) => {
    setValue(e.target.value);
    props.selectProps.onInputChange(e.target.value);
  };
  
  return (
    <input 
      ref={inputRef} 
      placeholder={props.getValue().length ? props.getValue()[0][props.selectProps.mainField] : props.selectProps.placeholder}
      value={value}
      onInput={handleInput}
      style={{
        outline: 'none',
        border: 'none',
        background: 'transparent',
        fontWeight: 400
      }}
    />
  );
};

export const ValueLabel = ({ label }) => (
  <Box
    pl={2}
    title={typeof label === 'string' ? label : undefined}
    sx={{
      flex: 1,
      minWidth: 0,
      color: '#464646',
      fontSize: 12,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }}
  >
    {label}
  </Box>
)

const ValueContainer = (props) => {
  const theme = useTheme();
  
  if (props.selectProps.menuIsOpen && props.selectProps.isSearchable) {
    return (
      <Box pl={2} sx={{ color: theme.palette.grey[500], fontSize: 12 }}>
        <InputValue {...props} />
      </Box>
    )
  }

  const label = props.selectProps.value === null
    ? props.selectProps.placeholder
    : props.selectProps.value[props.selectProps.mainField]

  return <ValueLabel label={label} />
};

export default ValueContainer;